// Add this utility somewhere in your frontend (e.g., utils/roleMapper.ts)
import { UserRole } from '../types/portal';

export function mapBackendRoleToFrontend(role: string): UserRole {
    const lastPart = role.substring(role.lastIndexOf('_') + 1);
    switch (lastPart) {
        case 'ADMIN':
        case 'ADMINISTRATOR':
        case 'SUPER_ADMIN':
            return UserRole.ADMIN;
        case 'TEACHER':
            return UserRole.TEACHER;
        case 'STUDENT':
            return UserRole.STUDENT;
        default:
            return UserRole.TEACHER; // Default to TEACHER instead of ADMIN for safety
    }
}